// NPM
import React, { Component } from 'react';

// Components
import HeaderNavigation from './HeaderNavigation';
import AuthNavWrapper from './AuthNavWrapper';

// External Components
import { Navbar } from 'frontend-component-library';

class DesktopNavbar extends Component {
  render() {
    return (
      <Navbar className="desktop-only">
        <HeaderNavigation />
        <AuthNavWrapper />
      </Navbar>
    );
  }
}

export default DesktopNavbar;



// WEBPACK FOOTER //
// ./src/Components/Layout/DesktopNavbar.js